import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import localforage from 'localforage';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { langEn } from './locales/en';
import { langJa } from './locales/ja';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import { CssBaseline } from '@mui/material';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports'; // if you are using the aws-exports.js file
import { Authenticator } from '@aws-amplify/ui-react';

Amplify.configure(awsExports);

const AppContiner = () => {
  const [isI18nextInitialized, setI18nextInitialized] = useState(false);
  useEffect(() => {
    localforage.getItem<string>('lang', (err: any, value: string | null) => {
      if (!i18next.isInitialized) {
        i18next
          .use(initReactI18next)
          .init({
            resources: {
              en: { translation: langEn },
              ja: { translation: langJa },
            },
            lng: value ? value : 'ja',
            fallbackLng: 'ja',
            returnEmptyString: false,
            debug: process.env.NODE_ENV === 'development',
            react: {
              transKeepBasicHtmlNodesFor: ['wbr', 'br'],
            },
          })
          .then(() => {
            setI18nextInitialized(true);
          });
      }
    });
  }, []);

  if (!isI18nextInitialized) {
    return <div>Loading translations...</div>;
  }
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Authenticator.Provider>
        <AppContiner />
      </Authenticator.Provider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
